import script from "./TalentTypeToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentTypeToggle.vue?vue&type=script&setup=true&lang=js"

import "./TalentTypeToggle.vue?vue&type=style&index=0&id=5a5ef2b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5ef2b1"]])

export default __exports__